import { Component, ChangeDetectionStrategy } from '@angular/core';
import { CardContentComponent } from '../../shared/components/card/card-content.component';
import { CardComponent } from '../../shared/components/card/card.component';
import { LogControlsComponent } from '../settings/log-controls/log-controls.component';

@Component({
  selector: 'app-logging',
  standalone: true,
  imports: [CardComponent, CardContentComponent, LogControlsComponent],
  templateUrl: './logging.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './logging.component.css',
})
export class LoggingComponent {}
